import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'
import { validateNumericString } from '~/utils/validations'

export const GET_VISITOR_QUERY_KEY = 'get-visitor' as const

export const useGetVisitor = ({ id }: { id: string | undefined }) => {
  return useQuery({
    queryKey: [GET_VISITOR_QUERY_KEY, id] as const,
    queryFn: async () => {
      if (!id) throw new Error('"id" is required to make this request')

      const validation = validateNumericString(id)
      if (!validation.success) throw new Error('"id" must be a valid number to make this request')

      const { data, error } = await supabaseApi
        .from('visitors')
        .select('*')
        .eq('id', validation.data)
        .limit(1)
        .single()

      if (!data) throw error

      return data
    },
    enabled: !!id,
  })
}
